import React from 'react';
import Navigation from './Navigation';

const CartPage = ({ 
  currentUser, 
  currentPage, 
  setCurrentPage, 
  cart, 
  logout, 
  removeFromCart, 
  makePurchase 
}) => {
  const total = cart.reduce((sum, item) => sum + item.price, 0);

  const handleRemoveFromCart = (productId, productTitle) => {
    if (window.confirm(`Remove "${productTitle}" from cart?`)) {
      removeFromCart(productId);
    }
  };

  const handlePurchase = () => {
    if (cart.length === 0) return;
    
    if (window.confirm(`Complete purchase of ${cart.length} item(s) for $${total.toFixed(2)}?`)) {
      makePurchase();
    }
  };

  return (
    <div className="container">
      <div className="header">
        <h1>🌱 EcoFinds</h1>
        <Navigation 
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          cart={cart}
          logout={logout}
        />
      </div>
      
      <h2>Shopping Cart ({cart.length} items)</h2>
      
      {cart.length === 0 ? (
        <div className="form">
          <p>Your cart is empty.</p>
          <p>Browse our products to find something you like!</p>
          <button onClick={() => setCurrentPage('browse')}>
            Browse Products
          </button>
        </div>
      ) : (
        <>
          <div style={{marginBottom: '20px'}}>
            {cart.map(item => (
              <div key={item.id} className="cart-item">
                <div>
                  <h3>{item.title}</h3>
                  <p><strong>Category:</strong> {item.category}</p>
                  <p style={{color: '#666', fontSize: '14px', margin: '5px 0'}}>
                    {item.description.substring(0, 100)}...
                  </p>
                  <p className="price">${item.price}</p>
                </div>
                <button onClick={() => handleRemoveFromCart(item.id, item.title)}>
                  Remove
                </button>
              </div>
            ))}
          </div>
          
          <div className="form" style={{marginTop: '20px'}}>
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px'}}>
              <h3>Total: ${total.toFixed(2)}</h3>
              <div>
                <button onClick={() => setCurrentPage('browse')} style={{background: '#666', marginRight: '10px'}}>
                  Continue Shopping
                </button>
                <button onClick={handlePurchase}>
                  Complete Purchase
                </button>
              </div>
            </div>
            
            <div style={{fontSize: '12px', color: '#666'}}>
              <p>• All purchases are final</p>
              <p>• Items will be reserved for 24 hours after purchase</p>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default CartPage;